'use strict';

angular.module('mobile-apps')
	.directive('appQuickInfo',['$state', function($state) {
		return {
			scope:
			{
				appData : '=',
				entryCount : '=',
				appSelectedCallback : '&'
			},
			replace: true,
			templateUrl: 'modules/mobile-apps/views/app-quick-info.client.view.html',
			link: function (scope, elem, attrs) {

				/**
				 * Gets executed whenever an app gets selected. It then either
				 * calls the given callback function or does the default which
				 * is going to the according app page
		         */
				scope.appSelected = function(appId, $event) {
					var callbackFunction = scope.appSelectedCallback();
					if (callbackFunction && angular.isFunction(callbackFunction)) {
						// Call the custom callback function
						callbackFunction(appId, $event);
					} else {
						let url = `!/#/projects/${appId}`;
						// Default behaviour go to selected app
						if ($event.ctrlKey || $event.metaKey) {
							// var url = $state.href('viewMobileApp', {mobileAppId: appId}, {absolute: true});
							window.open(url, '_blank');
						} else {
							//$state.go('viewMobileApp', {mobileAppId: appId});
							location.href = url;
						}
					}
				};

				scope.trimString = function(text, maxLength)
				{
					if(!text) return '';
					if(typeof maxLength === 'undefined')
					{
						maxLength = 36;
					}
					var result = text;
					var dots = '...';
					if(text.length > maxLength)
					{
						result = text.slice(0,maxLength - 1 - dots.length) + dots;
					}
					return result;
				};

			}
		};
	}]);
